/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import { Link } from "react-router-dom";

export class Navbar extends Component {

  constructor(props) {
    super(props)
  
    this.state = {
      checked : false,
    }

  }

  changechecked = () => {
    this.setState(prevState => ({
      checked: !prevState.checked
    }));
  }
  

  render() {


    const links = (
      <React.Fragment>
          <li>
            <Link to="/" className="link">HOME </Link>
          </li>
          <li>
            <Link to="/about" className="link">ABOUT </Link>
          </li>
          <li>
            <Link to="/skills" className="link">SKILLS </Link>
          </li>
          <li>
            <Link to="/projects" className="link">PORTFOLIO </Link>
          </li>
          <li>
            <Link to="/contact" className="link">CONTACT </Link>
          </li>
      </React.Fragment>
    );

    return (
      <React.Fragment>
        <nav className="nav">

          <div className="logoHolder">
            <img
              className="logo"
              src="assets/img/logo-v2-wht-center.png"
              alt=""
            />
          </div>

          <div className="menu-wrap">
          
            <input type="checkbox" className="toggler" autocomplete="off" onClick={() =>this.changechecked()}/>

            <div className="hamburger"> <div></div> </div>

            <div className={ 
                this.state.checked === true ? "menu menu-shown" : "menu"}
              >
                <ul className={ 
                    this.state.checked === true ? "mobileLinkshown" : "mobileLinkshide"}
                  >
                  { links }
                </ul>
            </div>

            
          </div>

          <div className="container">
            <ul className="navlinks">{ links }</ul>
          </div>

      
        </nav>
      </React.Fragment>
    );
  }
}

export default Navbar;
